import FileSaver from 'file-saver';
import { userService } from '@saucelabs/sl-util-axios';

import { generateReportName } from './../activity/utils';

export const getTeam = ({ id }) => (
  userService.get(`/v1/teams/${id}/`)
);

export const patchTeam = ({ id, data }) => (
  userService.patch(`/v1/teams/${id}/`, data)
);

export const getTeamUsersUsageCSV = ({ id, name }) => (
  userService.get(`/v1/teams/${id}/members-activity/`, {
    headers: {
      Accept: 'text/csv',
    },
    responseType: 'blob',
  }).then(({ data }) => {
    FileSaver.saveAs(data, generateReportName({
      rootSection: name,
      reportType: 'all',
    }));
  })
);
